import React, { useState } from "react";
import {
  fmt$,
  pct,
  md,
  dmd,
  longD,
  dnum,
  vcls,
  combNet,
  promoNet,
  bucket,
  r2,
  VERDICT_NEXT,
} from "./promoRadarData";

export default function PromoDrawer({
  isOpen,
  onClose,
  type, // 'night' or 'promo'
  nightIndex,
  promoId,
  radarData,
  onOpenNight,
  onOpenPromo,
  onToast,
}) {
  const [resQ, setResQ] = useState("");
  const [resSort, setResSort] = useState({ k: "stay", d: 1 });

  const CELL_BG = {
    OK: "var(--c-ok)",
    L1: "var(--c-l1)",
    L2: "var(--c-l2)",
    L3: "var(--c-l3)",
  };

  if (!isOpen || !radarData) return null;

  const {
    nights,
    pr,
    active,
    sf,
    code,
    leak,
    leaks,
    bk,
    nightsIn,
    firstN,
    chColor,
    chNames,
    getLeakAction,
    config,
  } = radarData;

  // RENDER NIGHT DRAWER
  if (type === "night" && nightIndex != null && nights[nightIndex]) {
    const x = nights[nightIndex];
    const OnTheBook = x.OnTheBook != null ? Math.round(x.OnTheBook).toLocaleString() : (x.otbR != null ? Math.round(x.otbR).toLocaleString() : "—");
    const stlyotb = x.stlyotb != null ? Math.round(x.stlyotb).toLocaleString() : (x.stlyR != null ? Math.round(x.stlyR).toLocaleString() : "—");
    const RMS = x.RMS != null ? Math.round(x.RMS).toLocaleString() : (x.fcR != null ? Math.round(x.fcR).toLocaleString() : "—");
    const LeftToSell = x.LeftToSell != null ? Math.round(x.LeftToSell) : (x.leftToSell != null ? Math.round(x.leftToSell) : x.rem);
    const Rate = fmt$(x.Rate != null ? x.Rate : x.bar);
    const ADR = fmt$(x.ADR != null ? x.ADR : x.adr);
    const act = pr
      .map((p, i) => ({ p, i, c: code[i]?.[nightIndex] }))
      .filter((o) => o.c);

    const gmax = Math.max(1, ...chNames.flatMap((c) => [x.ty[c] || 0, x.ly[c] || 0]));

    return (
      <>
        <div className="PromoRadar-scrim on" onClick={onClose} />
        <aside
          className="PromoRadar-drawer on"
          role="dialog"
          aria-modal="true"
          aria-labelledby="dTitle"
        >
          <div className="dhead">
            <div>
              <div className="reason">{`${x.dba} days out${x.ev ? ", " + x.ev : ""}`}</div>
              <h2 id="dTitle">{longD(x.d)}</h2>
              <div>
                <span className={`badge ${x.blackout ? "c-L1" : "c-OK"}`}>
                  {x.blackout ? "Blackout night" : "Open for promotions"}
                </span>{" "}
                <span className="reason">{x.diag}</span>
              </div>
            </div>
            <button className="xbtn" type="button" onClick={onClose} aria-label="Close">
              ×
            </button>
          </div>

          <div className="dbody">
            <div className="sec">
              <div className="mk">
                <div>
                  <div className="k">On the books</div>
                  <div className="v num">{OnTheBook}</div>
                  <div className="d">STLY {stlyotb}</div>
                </div>
                <div>
                  <div className="k">System Forecast</div>
                  <div className="v num">{RMS}</div>
                  <div className="d">{LeftToSell} rooms still to sell</div>
                </div>
                <div>
                  <div className="k">BAR</div>
                  <div className="v num">{Rate}</div>
                  <div className="d">ADR {ADR}</div>
                </div>
                <div>
                  <div className="k">Hurdle</div>
                  <div className="v num">{fmt$(x.hurdle)}</div>
                  <div className="d">{pct(x.tier)} of BAR</div>
                </div>
              </div>
              <p className="reason" style={{ marginTop: "10px" }}>
                {x.blackout
                  ? "Yield Radar marks this night as one that will sell at full rate (P1), so every discount on it is a leak."
                  : x.rec === "Promotion"
                    ? `Soft night. Yield Radar suggests ${x.owner} ${x.ptype.toLowerCase()}${x.pdisc ? " at " + pct(x.pdisc) : ""}.`
                    : "Healthy night. No new promotion needed."}
              </p>
            </div>

            <div className="sec">
              <h3>Promotions bookable this night</h3>
              {act.length ? (
                <div className="tablewrap">
                  <table>
                    <thead>
                      <tr>
                        <th>Promotion</th>
                        <th className="r">Promo net</th>
                        <th>Status</th>
                        <th className="r">At risk</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {act.map((o) => {
                        const effectiveNet =
                          o.c === "L3"
                            ? combNet(
                                o.p,
                                x.bar,
                                (sf[o.p.ch] || [])[nightIndex] || 1,
                              )
                            : promoNet(o.p, x.bar);
                        const atRiskAmt = (leak[o.i] || [])[nightIndex] || 0;
                        return (
                          <tr
                            key={o.p.id}
                            className="click"
                            onClick={() => onOpenPromo(o.p.id)}
                          >
                            <td>
                              <span className="ch">
                                <span
                                  className="dot"
                                  style={{ background: chColor[o.p.ch] }}
                                />
                                {o.p.id}
                              </span>
                              <div className="reason">{o.p.name}</div>
                            </td>
                            <td className="r num">{fmt$(effectiveNet)}</td>
                            <td>
                              <span className={`badge c-${o.c}`}>
                                {o.c === "OK" ? "Safe" : o.c}
                              </span>
                            </td>
                            <td className="r num">
                              {atRiskAmt ? fmt$(atRiskAmt) : "—"}
                            </td>
                            <td className="reason">
                              {getLeakAction(o.i, nightIndex) || "No change"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="reason">No promotion is bookable for this night.</p>
              )}
            </div>

            <div className="sec">
              <h3>Rooms by channel vs. last year</h3>
              <p className="hint">
                Coloured bar is this year, grey is the same time last year.
              </p>
              {chNames.map((c) => {
                const tyVal = x.ty[c] || 0;
                const lyVal = x.ly[c] || 0;
                const diff = tyVal - lyVal;
                return (
                  <div
                    key={c}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "110px 1fr 70px",
                      gap: "10px",
                      alignItems: "center",
                      margin: "8px 0",
                      fontSize: "13px",
                    }}
                  >
                    <div>{c}</div>
                    <div>
                      <div className="bar">
                        <span
                          style={{
                            width: `${(tyVal / gmax) * 100}%`,
                            background: chColor[c],
                          }}
                        />
                      </div>
                      <div className="bar" style={{ marginTop: "3px" }}>
                        <span
                          style={{
                            width: `${(lyVal / gmax) * 100}%`,
                            background: "var(--muted)",
                          }}
                        />
                      </div>
                    </div>
                    <div className="r num">
                      {diff >= 0 ? "+" : ""}
                      {diff}
                    </div>
                  </div>
                );
              })}
            </div>

            
          </div>
        </aside>
      </>
    );
  }

  // RENDER PROMOTION DRAWER
  if (type === "promo" && promoId) {
    const promoIdx = pr.findIndex((p) => p.id === promoId);
    const p = pr[promoIdx];
    if (!p) return null;
    const f = p.perf || {};

    const win = nights.filter(
      (x, k) => active[promoIdx]?.[k] || (x.n >= p.ss && x.n <= p.se),
    );
    const avgBar = win.length
      ? win.reduce((t, x) => t + x.bar, 0) / win.length
      : 0;
    const avgH = win.length
      ? win.reduce((t, x) => t + x.hurdle, 0) / win.length
      : 0;
    const disc = avgBar * p.disc;
    const commA = avgBar * (1 - p.disc) * p.comm;
    const feeA = avgBar * (1 - p.disc) * p.fee;
    const net = avgBar - disc - commA - feeA - p.pkg;
    const mx = Math.max(avgBar, avgH) * 1.05;
    const w = (v) => (mx > 0 ? (v / mx) * 100 : 0);

    const conf = bk.filter((b) => b.promo === p.id && b.status === "Confirmed");
    const byNight = nights.map((x, k) => ({
      x,
      k,
      n: conf.filter((b) => b.stay === x.d).length,
    }));
    const maxN = Math.max(1, ...byNight.map((b) => b.n));

    // Booking pace weeks
    const weeks = [0, 1, 2, 3, 4, 5].map((j) => {
      const s = dnum("2026-08-31") + 7 * j;
      const d0 = new Date(
        Date.parse("2026-08-31T12:00:00Z") + 7 * j * 864e5,
      )
        .toISOString()
        .slice(0, 10);
      return {
        lab: md(d0),
        v: conf.filter(
          (b) => dnum(b.booked) >= s && dnum(b.booked) < s + 7,
        ).length,
      };
    });

    // Lead time buckets
    const buckets = ["0-3", "4-7", "8-14", "15-30", "31-60", "61+"].map((b) => ({
      b,
      v: conf.filter((c) => bucket(c.lead) === b).length,
    }));
    const maxB = Math.max(1, ...buckets.map((b) => b.v));

    // LOS
    const los = [1, 2, 3, 4].map((n) => ({
      n,
      v: bk.filter(
        (b, j) =>
          b.promo === p.id &&
          firstN[b.conf] === j &&
          (n === 4 ? nightsIn[b.conf] >= 4 : nightsIn[b.conf] === n),
      ).length,
    }));
    const maxL = Math.max(1, ...los.map((l) => l.v));

    const promoLeaks = leaks.filter((l) => l.i === promoIdx);

    const trace = [
      [
        "Status",
        p.status,
        p.status === "Live",
        "Planned and paused promotions get Pre-launch / Paused (V0)",
      ],
      [
        "Sample",
        `${f.G || 0} nights, ${f.AG || 0} days live`,
        f.verdict === "Too early",
        `Need ${config.minSample} nights and ${config.minDaysLive} days (V1)`,
      ],
      [
        "Baseline",
        `${(f.U || 0).toFixed(1)} nights`,
        false,
        `Channel STLY ${f.Q || 0} × market factor ${(f.T || 1).toFixed(2)}`,
      ],
      [
        "Incremental",
        `${(f.X || 0).toFixed(1)} of ${f.G || 0} (${pct(f.Y || 0)})`,
        false,
        `Channel TY ${f.P || 0} − baseline = ${(f.V || 0).toFixed(1)}, shared pro rata across ${f.W || 0} promo nights on ${p.ch}`,
      ],
      [
        "Net impact",
        fmt$(f.AC || 0),
        false,
        `${fmt$(f.AA || 0)} from new demand − ${fmt$(f.AB || 0)} ${f.vis ? "fees" : "given away on bookings that would have come anyway"}`,
      ],
      ["ROI", (f.AD || 0).toFixed(2), false, `Net impact ÷ promotion cost ${fmt$(f.O || 0)}`],
      ["Verdict", `${f.verdict} (${f.rule})`, true, VERDICT_NEXT[f.verdict] || ""],
    ];

    const rcols = [
      ["conf", "Confirmation"],
      ["stay", "Night"],
      ["booked", "Booked"],
      ["lead", "Lead", "r"],
      ["nights", "Nights", "r"],
      ["room", "Room"],
      ["rate", "Rate", "r"],
      ["bar", "BAR", "r"],
      ["disc", "Discount", "r"],
      ["net", "Net", "r"],
      ["blackout", "Blackout"],
      ["status", "Status"],
    ];

    const filteredBookings = bk
      .filter((b) => {
        if (b.promo !== p.id) return false;
        if (!resQ) return true;
        return (
          b.conf.toLowerCase().includes(resQ.toLowerCase()) ||
          b.room.toLowerCase().includes(resQ.toLowerCase())
        );
      })
      .map((b) => ({ ...b, nights: nightsIn[b.conf] || 1 }))
      .sort((a, b) => {
        const u = a[resSort.k];
        const v = b[resSort.k];
        const res =
          typeof u === "number"
            ? u - v
            : String(u || "").localeCompare(String(v || ""));
        return res * resSort.d;
      });

    const exportCSV = () => {
      const head = [
        "confirmation_no",
        "promotion_id",
        "channel",
        "stay_date",
        "booking_date",
        "lead_days",
        "nights",
        "room_type",
        "nightly_rate",
        "bar",
        "discount",
        "promo_net",
        "blackout",
        "status",
      ];
      const rows = filteredBookings.map((b) => [
        b.conf,
        b.promo,
        `"${b.ch}"`,
        b.stay,
        b.booked,
        b.lead,
        b.nights,
        b.room,
        b.rate,
        b.bar,
        b.disc,
        r2(b.net),
        b.blackout ? "Yes" : "No",
        b.status,
      ]);
      const csv = [head.join(",")]
        .concat(rows.map((r) => r.join(",")))
        .join("\n");
      try {
        const u = URL.createObjectURL(
          new Blob([csv], { type: "text/csv;charset=utf-8;" }),
        );
        const a = document.createElement("a");
        a.href = u;
        a.download = `promo_bookings_${p.id}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(u), 1000);
        if (onToast) onToast("CSV exported");
      } catch (e) {
        if (onToast) onToast("Export is not available here");
      }
    };

    return (
      <>
        <div className="PromoRadar-scrim on" onClick={onClose} />
        <aside
          className="PromoRadar-drawer on"
          role="dialog"
          aria-modal="true"
          aria-labelledby="dTitle"
        >
          <div className="dhead">
            <div>
              <div className="reason">{`${p.ch}, ${p.type}, ${p.source === "Scraper" ? "detected by scraper" : "entered by RM"}`}</div>
              <h2 id="dTitle">{`${p.id} ${p.name}`}</h2>
              <div>
                <span className={`badge ${vcls(f.verdict)}`}>
                  {f.verdict}
                </span>{" "}
                <span className="reason">
                  {p.status}, stay {md(p.raw[7])} to {md(p.raw[8])}
                  {p.leakN ? (
                    <b style={{ color: "var(--l1)" }}>
                      , {p.leakN} leak nights
                    </b>
                  ) : (
                    ""
                  )}
                </span>
              </div>
            </div>
            <button className="xbtn" type="button" onClick={onClose} aria-label="Close">
              ×
            </button>
          </div>

          <div className="dbody">
            <div className="sec">
              <div className="mk">
                <div>
                  <div className="k">Room nights</div>
                  <div className="v num">{f.G || 0}</div>
                  <div className="d">
                    Target {p.target}
                    {f.vis ? " incremental" : ""}
                  </div>
                </div>
                <div>
                  <div className="k">Net ADR</div>
                  <div className="v num">{f.G ? fmt$(f.K) : "—"}</div>
                  <div className="d">
                    Full rate net {f.G ? fmt$(f.L / f.G) : "—"}
                  </div>
                </div>
                <div>
                  <div className="k">Net impact</div>
                  <div
                    className="v num"
                    style={{ color: f.AC < 0 ? "var(--l1)" : "inherit" }}
                  >
                    {fmt$(f.AC)}
                  </div>
                  <div className="d">ROI {(f.AD || 0).toFixed(2)}</div>
                </div>
                <div>
                  <div className="k">Leak at risk</div>
                  <div
                    className="v num"
                    style={{ color: p.leak$ ? "var(--l1)" : "inherit" }}
                  >
                    {fmt$(p.leak$)}
                  </div>
                  <div className="d">
                    {p.leakN} of {p.activeN} bookable nights
                  </div>
                </div>
              </div>
              <p className="reason" style={{ marginTop: "10px" }}>
                <b>Next step:</b>{" "}
                {p.leakN ? "Fix leakage first: " + p.leakAction + " Then: " : ""}
                {VERDICT_NEXT[f.verdict]}.
              </p>
            </div>

            <div className="sec">
              <h3>What the hotel keeps per night</h3>
              <p className="hint">
                Average night in the promotion window: BAR {fmt$(avgBar)}, hurdle{" "}
                {fmt$(avgH)}.
              </p>
              <div className="wf">
                <div>BAR</div>
                <div className="tr">
                  <span
                    style={{
                      left: 0,
                      width: `${w(avgBar)}%`,
                      background: "var(--panel-2)",
                      border: "1px solid var(--line)",
                    }}
                  />
                </div>
                <div className="r num">{fmt$(avgBar)}</div>

                <div>Discount {pct(p.disc)}</div>
                <div className="tr">
                  <span
                    style={{
                      left: `${w(avgBar - disc)}%`,
                      width: `${w(disc)}%`,
                      background: "var(--l2-bg)",
                      border: "1px solid var(--l2)",
                    }}
                  />
                </div>
                <div className="r num">−{fmt$(disc)}</div>

                <div>Commission {pct(p.comm)}</div>
                <div className="tr">
                  <span
                    style={{
                      left: `${w(avgBar - disc - commA)}%`,
                      width: `${w(commA)}%`,
                      background: "var(--l1-bg)",
                      border: "1px solid var(--l1)",
                    }}
                  />
                </div>
                <div className="r num">−{fmt$(commA)}</div>

                <div>Program fee {pct(p.fee)}</div>
                <div className="tr">
                  <span
                    style={{
                      left: `${w(avgBar - disc - commA - feeA)}%`,
                      width: `${w(feeA)}%`,
                      background: "var(--l3-bg)",
                      border: "1px solid var(--l3)",
                    }}
                  />
                </div>
                <div className="r num">−{fmt$(feeA)}</div>

                <div>Package cost</div>
                <div className="tr">
                  <span
                    style={{
                      left: `${w(net)}%`,
                      width: `${w(p.pkg)}%`,
                      background: "var(--l1-bg)",
                      border: "1px solid var(--l1)",
                    }}
                  />
                </div>
                <div className="r num">−{fmt$(p.pkg)}</div>

                <div>
                  <b>Promotion net</b>
                </div>
                <div className="tr">
                  <span
                    style={{
                      left: 0,
                      width: `${w(net)}%`,
                      background: net >= avgH ? "var(--ok)" : "var(--l1)",
                    }}
                  />
                  <span
                    style={{
                      left: `${w(avgH)}%`,
                      width: "2px",
                      background: "var(--text)",
                    }}
                  />
                </div>
                <div className="r num">
                  <b>{fmt$(net)}</b>
                </div>
              </div>
            </div>

            {f.G > 0 && (
              <div className="sec">
                <h3>New demand vs. bookings that would have come anyway</h3>
                <p className="hint">
                  Baseline is last year's {p.ch} volume for the same nights,
                  adjusted for how the rest of the hotel is pacing.
                </p>
                <div style={{ margin: "6px 0" }}>
                  <HorizontalBar
                    label="Channel this year"
                    val={f.P}
                    segs={[{ x: 0, w: f.P, c: chColor[p.ch] }]}
                    max={Math.max(f.P, f.U, f.G)}
                  />
                  <HorizontalBar
                    label="Baseline"
                    val={f.U.toFixed(0)}
                    segs={[{ x: 0, w: f.U, c: "var(--muted)" }]}
                    max={Math.max(f.P, f.U, f.G)}
                  />
                  <HorizontalBar
                    label="This promotion"
                    val={f.G}
                    segs={[
                      { x: 0, w: f.X, c: "var(--ok)" },
                      { x: f.X, w: f.Z, c: "var(--l2)" },
                    ]}
                    max={Math.max(f.P, f.U, f.G)}
                  />
                </div>
                <div className="legend" style={{ marginTop: "8px" }}>
                  <span>
                    <i style={{ background: "var(--ok)" }} />
                    Incremental {(f.X || 0).toFixed(0)}
                  </span>
                  <span>
                    <i style={{ background: "var(--l2)" }} />
                    Would have booked anyway {(f.Z || 0).toFixed(0)}
                  </span>
                </div>
              </div>
            )}

            <div className="sec">
              <h3>Nights</h3>
              <p className="hint">
                Bars show this promotion's room nights per night. The strip
                below is the calendar status. Select a bar to open that night.
              </p>
              <div className="strip">
                {byNight.map((b) => (
                  <button
                    key={b.k}
                    type="button"
                    title={`${dmd(b.x.d)}: ${b.n} nights`}
                    aria-label={`${dmd(b.x.d)}, ${b.n} room nights`}
                    style={{
                      height: `${Math.max(3, (b.n / maxN) * 100)}%`,
                      background: b.n ? chColor[p.ch] : "var(--panel-2)",
                    }}
                    onClick={() => onOpenNight(b.k)}
                  />
                ))}
              </div>
              <div className="stripc">
                {nights.map((x, k) => (
                  <span
                    key={k}
                    style={{
                      background: code[promoIdx]?.[k]
                        ? CELL_BG[code[promoIdx][k]]
                        : "var(--panel-2)",
                    }}
                  />
                ))}
              </div>
              <div
                className="reason"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "4px",
                }}
              >
                <span>{md(nights[0].d)}</span>
                <span>{md(nights[nights.length - 1].d)}</span>
              </div>
            </div>

            {!f.vis && (
              <>
                <div className="sec">
                  <h3>Booking pace</h3>
                  <p className="hint">
                    Room nights booked per week since launch.
                  </p>
                  <SvgLineChart
                    series={[{ pts: weeks.map((x) => x.v), c: chColor[p.ch] }]}
                    labels={weeks.map((x) => x.lab)}
                    aria="Room nights booked per week"
                  />
                </div>

                <div
                  className="sec"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "18px",
                  }}
                >
                  <div>
                    <h3>Lead time</h3>
                    <p className="hint">Days between booking and the night.</p>
                    {buckets.map((b) => (
                      <HorizontalBar
                        key={b.b}
                        label={`${b.b} days`}
                        val={b.v}
                        segs={[{ x: 0, w: b.v, c: chColor[p.ch] }]}
                        max={maxB}
                      />
                    ))}
                  </div>
                  <div>
                    <h3>Length of stay</h3>
                    <p className="hint">Reservations by nights.</p>
                    {los.map((l) => (
                      <HorizontalBar
                        key={l.n}
                        label={
                          l.n === 4
                            ? "4+ nights"
                            : `${l.n} night${l.n > 1 ? "s" : ""}`
                        }
                        val={l.v}
                        segs={[{ x: 0, w: l.v, c: chColor[p.ch] }]}
                        max={maxL}
                      />
                    ))}
                  </div>
                </div>
              </>
            )}

            {promoLeaks.length > 0 && (
              <div className="sec">
                <h3>Leak nights</h3>
                <p className="hint">{p.leakAction}</p>
                <div className="tablewrap" style={{ maxHeight: "240px", overflow: "auto" }}>
                  <table>
                    <thead>
                      <tr>
                        <th>Night</th>
                        <th>Rule</th>
                        <th className="r">At risk</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {promoLeaks.map((l) => (
                        <tr
                          key={l.k}
                          className="click"
                          onClick={() => onOpenNight(l.k)}
                        >
                          <td>{dmd(nights[l.k].d)}</td>
                          <td>
                            <span className={`badge c-${l.code}`}>
                              {l.code}
                            </span>
                          </td>
                          <td className="r num">{fmt$(l.amt)}</td>
                          <td className="reason">
                            {getLeakAction(l.i, l.k)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {!f.vis && (
              <div className="sec">
                <h3>Room-night bookings</h3>
                <p className="hint">
                  One row per reservation per night, from the PMS feed with the
                  promotion code.
                </p>
                <div className="filters">
                  <input
                    type="search"
                    placeholder="Search confirmation"
                    value={resQ}
                    onChange={(e) => setResQ(e.target.value)}
                  />
                  <button
                    className="ghost"
                    type="button"
                    onClick={exportCSV}
                  >
                    Export CSV
                  </button>
                  <span className="reason">{filteredBookings.length} rows</span>
                </div>
                <div className="restable">
                  <table>
                    <thead>
                      <tr>
                        {rcols.map(([k, l, al]) => (
                          <th
                            key={k}
                            className={al || ""}
                            onClick={() =>
                              setResSort({
                                k,
                                d: resSort.k === k ? -resSort.d : 1,
                              })
                            }
                          >
                            {l}
                            {resSort.k === k
                              ? resSort.d > 0
                                ? " ▲"
                                : " ▼"
                              : ""}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredBookings.length > 0 ? (
                        filteredBookings.map((b, idx) => (
                          <tr
                            key={`${b.conf}-${idx}`}
                            style={{
                              opacity: b.status === "Cancelled" ? 0.5 : 1,
                            }}
                          >
                            <td className="num">{b.conf}</td>
                            <td>{md(b.stay)}</td>
                            <td>{md(b.booked)}</td>
                            <td className="r num">{b.lead}</td>
                            <td className="r num">{b.nights}</td>
                            <td>{b.room}</td>
                            <td className="r num">{fmt$(b.rate)}</td>
                            <td className="r num">{fmt$(b.bar)}</td>
                            <td className="r num">{fmt$(b.disc)}</td>
                            <td className="r num">{fmt$(b.net)}</td>
                            <td>
                              {b.blackout && (
                                <span className="badge c-L1">Yes</span>
                              )}
                            </td>
                            <td>{b.status}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={12}
                            className="muted"
                            style={{ padding: "16px" }}
                          >
                            No bookings recorded for this promotion.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <div className="sec">
              <h3>How the verdict was reached</h3>
              <ol className="trace">
                {trace.map((t, idx) => (
                  <li key={idx} className={t[2] ? "hit" : ""}>
                    <div>
                      <div className="q">{t[0]}</div>
                      <div className="f">{t[3]}</div>
                    </div>
                    <div className="val num">{t[1]}</div>
                  </li>
                ))}
              </ol>
            </div>

            
          </div>
        </aside>
      </>
    );
  }

  return null;
}

function HorizontalBar({ label, val, segs, max }) {
  const maximum = max || 1;
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "140px 1fr 80px",
        gap: "10px",
        alignItems: "center",
        margin: "6px 0",
        fontSize: "13px",
      }}
    >
      <div
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {label}
      </div>
      <div className="bar" style={{ height: "12px" }}>
        {segs.map((s, idx) => (
          <span
            key={idx}
            style={{
              left: `${(s.x / maximum) * 100}%`,
              width: `${(s.w / maximum) * 100}%`,
              background: s.c,
            }}
          />
        ))}
      </div>
      <div className="r num">{val}</div>
    </div>
  );
}

function SvgLineChart({ series, labels, aria }) {
  const W = 640;
  const H = 200;
  const L = 40;
  const R = 10;
  const T = 10;
  const B = 28;
  const ptsCount = series[0]?.pts?.length || 1;
  const maxVal =
    Math.max(1, ...series.flatMap((s) => s.pts)) * 1.15;

  const X = (i) => L + (i / Math.max(1, ptsCount - 1)) * (W - L - R);
  const Y = (v) => T + (1 - v / maxVal) * (H - T - B);

  return (
    <svg
      className="chart"
      viewBox={`0 0 ${W} ${H}`}
      role="img"
      aria-label={aria}
    >
      <rect
        x={L}
        y={T}
        width={W - L - R}
        height={H - T - B}
        fill="none"
        stroke="var(--line)"
      />
      {[0, 1, 2, 3].map((k) => {
        const v = (maxVal * k) / 3;
        return (
          <text
            key={k}
            x={L - 5}
            y={Y(v) + 3}
            textAnchor="end"
            fontSize="10"
            fill="var(--muted)"
            fontFamily="JetBrains Mono, monospace"
          >
            {Math.round(v)}
          </text>
        );
      })}
      {labels.map((lab, i) => (
        <text
          key={i}
          x={X(i)}
          y={H - B + 14}
          textAnchor="middle"
          fontSize="10"
          fill="var(--muted)"
        >
          {lab}
        </text>
      ))}
      {series.map((s, idx) => {
        const d = s.pts
          .map((v, i) => `${i ? "L" : "M"}${X(i).toFixed(1)},${Y(v).toFixed(1)}`)
          .join("");
        return (
          <path
            key={idx}
            d={d}
            fill="none"
            stroke={s.c}
            strokeWidth="2.2"
          />
        );
      })}
    </svg>
  );
}
